import { FC, SVGProps } from 'react';

export const ReadIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M21.4325 8.61665C20.9949 8.1869 20.2996 8.20479 19.8836 8.65533L9.4343 19.9699L4.61643 15.0015C4.18949 14.5612 3.49401 14.5612 3.06707 15.0015C2.64431 15.4375 2.64431 16.1412 3.06707 16.5772L8.67874 22.3642C8.88611 22.5781 9.1701 22.6981 9.46683 22.6943C9.76355 22.6906 10.0445 22.5635 10.2466 22.3447L21.47 10.1919C21.882 9.74573 21.8657 9.04217 21.4325 8.61665Z"
			fill="currentColor"
		/>
		<path
			d="M28.914 8.61665C28.4764 8.1869 27.7811 8.20479 27.3651 8.65533L16.9158 19.9699L15.9213 18.9443C15.7064 18.7228 15.3481 18.732 15.145 18.9644L14.3832 19.836C14.2025 20.0428 14.2106 20.3536 14.4017 20.5508L16.1602 22.3642C16.3676 22.5781 16.6516 22.6981 16.9483 22.6944C17.245 22.6906 17.526 22.5635 17.7281 22.3447L28.9515 10.1919C29.3635 9.74573 29.3472 9.04217 28.914 8.61665Z"
			fill="currentColor"
		/>
	</svg>
);
